import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonColor } from '@components/buttons/button/button.component';
export interface ConfirmDialogButton {
  label: string;
  color?: ButtonColor;
}

export interface ConfirmHeader {
  label: string;
  icon?: string;
}

export interface ConfirmDialogData {
  header: ConfirmHeader;
  message: string;
  secondaryMessage?: string;
  yesButton: ConfirmDialogButton;
  noButton: ConfirmDialogButton;
}

@Component({
  selector: 'vfs-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  cancel() {
    this.dialogRef.close(false);
  }

  accept() {
    this.dialogRef.close(true);
  }
}
